import GLOBAL from '../util/global';
import postXHR from '../util/xhr';
import getEntries from '../util/getEntries';

import Category from '../core/types/category.type';
import IMessage, { IShared } from '../core/types/message.type';
import IPV from '../core/types/pv.type';
import { IPerformanceMergedTime } from '../core/types/performance.type';

let FORMER_PV_FLAG: boolean = true;
let sharedData: IShared[] = [];

function _sendPVData(ctx: any, padding?: object) {
    const cache: IPV = {
        name: '',
        auto: ctx.autopv,
        referUrl: GLOBAL.document.referrer,
    };

    const mergedData: IMessage[] = [];

    const raw: IMessage = ctx.inspect();
    cache.name = ctx.core.pageId;
    if (padding) {
        cache.padding = padding;
    }
    if (GLOBAL.performance && GLOBAL.performance.timing && GLOBAL.performance.timing.navigationStart) {
        const {
            navigationStart,
            responseEnd,
            domInteractive,
            domComplete,
        } = GLOBAL.performance.timing;

        const perfTime: IPerformanceMergedTime = {
            responseEnd: responseEnd - navigationStart,
            firstPaint: 0,
            domInteractive: domInteractive - navigationStart,
            domComplete: domComplete - navigationStart,
            firstContentfulPaint: 0,
        };
        if (getEntries) {
            const allEntries = GLOBAL.performance.getEntries();
            const firstPaintEntry = allEntries.find((entry: any) => {
                return entry.name === 'first-paint';
            });
            const firstContentPaintEntry = allEntries.find((entry: any) => {
                return entry.name === 'first-contentful-paint';
            });
            if (firstPaintEntry && firstPaintEntry.startTime) {
                perfTime.firstPaint = Math.round(firstPaintEntry.startTime);
            }
            if (firstContentPaintEntry && firstContentPaintEntry.startTime) {
                perfTime.firstContentfulPaint = Math.round(firstContentPaintEntry.startTime);
            }
        }
        cache.performanceTime = perfTime;
    }

    raw.category = Category.PV;
    raw.pv = cache;
    mergedData.push(raw);

    const postData = [{
        common: sharedData,
        body: mergedData,
    }];

    postXHR({
        data: encodeURIComponent(JSON.stringify(postData)),
    });
}

function PVMiddleware(ctx: any, next: any): any {
    if (FORMER_PV_FLAG) {
        FORMER_PV_FLAG = false;
        sharedData = ctx.getShared();
        ctx.core.pageView = (padding: any): void => {
            if (GLOBAL.document.readyState === 'complete') {
                ctx.core.beat();
                _sendPVData(ctx, padding);
            } else {
                const pv = () => {
                    setTimeout(() => {
                        ctx.core.beat();
                        _sendPVData(ctx, padding);
                    }, 0);
                };
                GLOBAL.addEventListener("load", pv);
            }
        };
        if (ctx.autopv) {
            GLOBAL.addEventListener("load", () => {
                setTimeout(() => {
                    _sendPVData(ctx);
                }, 0);
            });
        }
    }
    next();
}

export default PVMiddleware;



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./node_modules/tslint-loader??ref--1!./src/middleware/pv-middleware.ts